import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type DeliveryTypesComponentProps = {
    allowClickAndCollect: boolean;
    allowHomeDelivery: boolean;
    className?: string;
};

const DeliveryTypesComponent = ({
    allowClickAndCollect,
    allowHomeDelivery,
    className
}: DeliveryTypesComponentProps) => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:flex tw:flex-col", "tw:sm:flex-row", className)}>
            {allowClickAndCollect && (
                <div
                    className={cn("tw:flex tw:items-center", {
                        "tw:pr-2": allowHomeDelivery
                    })}
                >
                    <i
                        className={
                            "tw:content-[''] tw:inline-block tw:w-2.5 tw:h-2.5 tw:rounded-full tw:bg-success tw:mr-1.5"
                        }
                    />
                    <span>
                        {t(
                            `productTile.delivery.type.${DeliveryType.ClickAndCollect}`
                        )}
                    </span>
                </div>
            )}
            {allowHomeDelivery && (
                <div className={cn("tw:flex tw:items-center")}>
                    <i
                        className={
                            "tw:content-[''] tw:inline-block tw:w-2.5 tw:h-2.5 tw:rounded-full tw:bg-success tw:mr-1.5"
                        }
                    />
                    <span>
                        {t(
                            `productTile.delivery.type.${DeliveryType.HomeDelivery}`
                        )}
                    </span>
                </div>
            )}
        </div>
    );
};

export default DeliveryTypesComponent;
